import * as React from 'react';
import * as styles from './SafeRentBlock.css';
import { Link } from '@cian/link-component';
import { CianAssistIcon } from './CianAssistIcon';
import { trackSafeRentBlockShow, trackSafeRentBlockHover } from './tracking';
import { SafeRentPopup } from '../SafeRentPopup';
import { OwnerBadge } from '@cian/owner-badge-component';

export const SafeRentBlock = () => {
  if (typeof window !== 'undefined') {
    trackSafeRentBlockShow();
  }

  return (
    <div className={styles['block']}>
      <OwnerBadge isVerified />

      <div className={styles['title']}>
        <div className={styles['icon']}>
          <CianAssistIcon />
        </div>

        Квартира сдаётся с услугой<br />
        «Безопасная аренда от ЦИАН»
      </div>

      <div className={styles['link-wrapper']}>
        <div className={styles['tooltip']}>
          <SafeRentPopup />
        </div>

        <Link onMouseOver={trackSafeRentBlockHover}>Что это значит?</Link>
      </div>
    </div>
  );
};
